import React from "react";
import PropTypes from "prop-types";
import useExtensionSurfacePreviewState from "../shared/useExtensionSurfacePreviewState";
import ExtensionUpsellWidget from "../shared/ExtensionUpsellWidget";
import {
  CheckoutPageSkeleton,
  ExtensionOrderSummarySidebar,
  pageShellStyles,
} from "../shared/ExtensionPageChrome";
import { SURFACE_WIDGET_BADGES } from "../shared/extension-preview-dummy-data";

export default function CheckoutEditorPreview({ popupData, popupState, setPopupState }) {
  const preview = useExtensionSurfacePreviewState({
    popupData,
    popupState,
    setPopupState,
  });

  const shopDomain = `${preview.storeLabel.toLowerCase().replace(/\s+/g, "-")}.myshopify.com`;

  return (
    <div
      ref={preview.popupRef}
      className={`${pageShellStyles.pageShell} ${
        preview.isMobile ? pageShellStyles.mobile : ""
      }`.trim()}
      data-testid="checkout-upsell-preview"
      data-extension-surface="CHECKOUT"
    >
      <div className={pageShellStyles.mainPane}>
        <div className={pageShellStyles.mainInner}>
          <p className={pageShellStyles.breadcrumb}>
            <span className={pageShellStyles.breadcrumbStrong}>{shopDomain}</span>
            {" "}
            &gt; Checkout
          </p>

          <ExtensionUpsellWidget
            surfaceBadge={SURFACE_WIDGET_BADGES.CHECKOUT}
            mapped={preview.mapped}
            popupData={popupData}
            activeStep={preview.activeStep}
            currentParentData={preview.currentParentData}
            selectedBlock={preview.selectedBlock}
            handleBlockClick={preview.handleBlockClick}
            isSelected={preview.isSelected}
            renderCta={preview.renderCta}
          />

          <CheckoutPageSkeleton />
        </div>
      </div>
      <ExtensionOrderSummarySidebar />
    </div>
  );
}

CheckoutEditorPreview.propTypes = {
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
};
